// SPDX-FileCopyrightText: 2026 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { useAppStatusApi } from 'hooks/useAppStatusApi';
import ReleaseChangeLogController from 'components/releaseChangeLog/ReleaseChangeLogController';
import React, { useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import type { NavOutletContext } from './Nav';

export default function AppController() {
  // we have to be sure that we are not in auth routes.
  // Thats why we need to call this hook here and not in ApplicationRouter.
  // Otherwise we would get a redirect loop when the user is not authenticated and the app status is not available yet.
  const { data: appStatus } = useAppStatusApi();
  const { releaseChangeLogOpen, onReleaseChangeLogOpenChange, onReleaseChangeLogAvailabilityChange } =
    useOutletContext<NavOutletContext>();

  useEffect(() => {
    onReleaseChangeLogAvailabilityChange(true);
    return () => {
      onReleaseChangeLogAvailabilityChange(false);
      onReleaseChangeLogOpenChange(false);
    };
  }, [onReleaseChangeLogAvailabilityChange, onReleaseChangeLogOpenChange]);

  return (
    <>
      <ReleaseChangeLogController
        open={releaseChangeLogOpen}
        uiVersionStatus={appStatus?.uiVersionStatus}
        onOpenChange={onReleaseChangeLogOpenChange}
      />
      <Outlet />
    </>
  );
}
